export default function passwordValidation(pwObject) {
  let errors = [];

  if (!pwObject.current_password) {
    errors.push({
      field: 'current_password',
      test: 'present',
      message: `Your current password is required`,
    })
  }

  if (!pwObject.password) {
    errors.push({
      field: 'password',
      test: 'present',
      message: `A new password is required`,
    })
  }

  if (!pwObject.confirmed_password) {
    errors.push({
      field: 'confirmed_password',
      test: 'present',
      message: `A confirmed new password is required`,
    })
  }

  if (pwObject.password !== pwObject.confirmed_password) {
    errors.push({
      field: 'confirmed_password',
      test: 'equal',
      message: `Your new password doesn't match`,
    })
  }

  let errorFields = errors.map(e => e.field);

  const validationObject = {
    messages: errors,
    fields: errorFields,
  }

  return validationObject;
}
